module.exports = "/_next/static/images/ab01f3ffbe087f4a70c45c7b34e56f5a-mulher-perfil-segurando-cartao-md@3x.jpg";